import { useEffect, useState } from 'react'

import { yupResolver } from '@hookform/resolvers/yup'
import { AccordionResume } from 'components'
import { TypesValidations } from 'constants/enums'
import type { Color, Material } from 'container/SalesOrder/interfaces'
import { FormProvider, useForm } from 'react-hook-form'
import * as yup from 'yup'

import ItemMaterialDetails from '../ItemMaterialDetails'

type ItemMaterialProps = {
  material: Material
}

export interface Ref {
  value: number
}

export interface ErrorObject {
  message: string
  type: string
  ref: Ref
}
const ItemMaterial = ({ material }: ItemMaterialProps) => {
  const colors = material?.cores?.map((color: Color) => color.ds_cor)
  const shouldValidate =
    material.fl_verf_sku === TypesValidations.YES &&
    !/\D/g.test(material.cores[0].tamanhos[0].cd_tamh)
  const [stateMateriais, setStateMateriais] = useState<Material>()
  const createSchema = (keys: string[]) =>
    yup.object().shape(
      keys?.reduce(
        (acc, key) => ({
          ...acc,
          [key]: yup.array().of(
            yup.number().test('is-multiple', 'esse numero não é multiplo', (value) => {
              if (shouldValidate) {
                return value ? value % material.qt_item_conv === 0 : true
              } else {
                return true
              }
            }),
          ),
        }),
        {},
      ),
    )
  useEffect(() => {
    setStateMateriais(material)
  }, [material])

  const methods = useForm({
    mode: 'onChange',
    resolver: yupResolver(createSchema(colors)),
    reValidateMode: 'onBlur',
  })

  return (
    <FormProvider {...methods}>
      {stateMateriais && (
        <AccordionResume
          errorStatus={material.stat}
          key={material.cd_matr}
          material={stateMateriais}
          onClick={() => {
            return
          }}
        >
          <ItemMaterialDetails material={material} />
        </AccordionResume>
      )}
    </FormProvider>
  )
}

export default ItemMaterial
